import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { initPreview } from './lib/preview';
import { installTypography } from './lib/typography';
import './index.css';

// Before React, not inside it: the first content request has to carry the token already,
// or the editor watches the published page render and then get replaced by their draft.
// It also takes the token out of the address bar, which is the other reason it is early.
initPreview();

const container = document.getElementById('root');
if (!container) throw new Error('#root element is missing from index.html');

// No one-letter word left at the end of a line; see lib/typography.ts for why CSS cannot.
installTypography(container);

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>
);
